import { Dispatch } from 'redux';

import { Thunk } from './types';

export const dispatchThunks = async (
  thunks: Thunk<Promise<any>>[] | undefined,
  dispatch: Dispatch<any>
) => {
  if (!thunks || !thunks.length) {
    return;
  }
  const promises = thunks.map((thunk) => dispatch(thunk()));
  const results: any = await Promise.all(promises);
  results.forEach((result: any) => {
    if (!result.ok) {
      // Log permission errors but don't throw to prevent breaking page initialization
      const errorMessage = result.errorMessage || '';
      const isPermissionError =
        errorMessage.includes('403') ||
        errorMessage.includes('Forbidden') ||
        errorMessage.toLowerCase().includes('access denied') ||
        errorMessage.includes('unauthorized') ||
        errorMessage.includes('permission') ||
        errorMessage.toLowerCase().includes('not authorized') ||
        errorMessage.includes('gated feature');

      if (isPermissionError) {
        console.warn(
          'Permission denied for rehydration thunk, continuing page load:',
          result.errorMessage
        );
      } else {
        throw new Error(result.errorMessage);
      }
    }
  });
};
